;(function ($) {
    $('.js-paper-more').on('click', function() {
        var el = $(this),
            container = el.parent();

        container.find('.js-paper-hidden').addClass('shown');

        el.hide();
    })
})(jQuery);
